import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const WST01 = lazy(() => import('@/pages/E02/WST01'));
const WST02 = lazy(() => import('@/pages/E02/WST02'));


function E02() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/E02/WST01" component={WST01} />
        <Route path="/E02/WST02" component={WST02} />
      </Switch>
    </Suspense>
  );
}

export default E02;
